/*
*###############################################################################
*Module Name                   : GroupMasterSetup.js                           #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Wednesday, September 1st 2021, 9:24:47 am     #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useContext, useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import GroupMasterSetupContent from "./GroupMasterSetupContent"
import DPInfoBox from "../../../framework/layout/DPInfoBox"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Text, Numeric } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPPermission from "framework/widgets/DPPermission"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';

const GroupMasterSetup = props => {

  let history = useHistory();
  const {
    getMenuDetails, addtoFavourite,isHeadOffice
  } = useContext(Context);

  //* Variable Declaration */


  const newObjetcArray = [{ id: 1, code: 1, desc: "", type: "", fieldLen: "", req: false }]


  const [setupArray, setSetupArray] = useState([...newObjetcArray])

  const [arGSDet, SetGSDet] = useState([{ id: 1 }])

  const [strFileNo, SetFileCode] = useState("")
  const [strFilename, SetFilename] = useState("")
  const [strMenuNo, SetMenuNo] = useState("")
  const [intCodeLength, SetCodeLength] = useState(0)
  const [intDescLength, SetDescLength] = useState(0)
  const [modal_xlarge, setmodal_xlarge] = useState(false)

  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [disabledDesc, setDisabledDesc] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [addNew, SetAddNew] = useState(true)
  const [Reason, setReason] = useState("Created")

  //Alert Parameter
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [ErrorMsg, setErrorMsg] = useState('')
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  //*End Variable DEclare */

  const [menuCode, SetMenuCode] = useState("")

  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)


  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [helpUrl, setHelpUrl] = useState("")

  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL

  var time = process.env.REACT_APP_ALERTTIMEOUT


  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)

    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setPermissionReasonShow(result.data.strMenuReasonShow)
        setHelpUrl(result.data.strHelpUrl)
        fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
          method: "GET",
          headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
          .then(responseData => {
            if (responseData.success == true) {
              if (responseData.data.length == 0) {
                setNullCode(true)
              } else {
                setAutoCode(responseData.data)
              }
            } else {
              setNullCode(true)
            }
          })
      }).catch(error =>
        console.log('error', error)
      );
  }, [])


  function handleAddRowNested() {
    const modifiedRows = [...setupArray]

    const hasEmptyRow = modifiedRows.find(x => x.desc == "" || x.fieldLen == "");

    if (hasEmptyRow) {
      return false;
    }

    modifiedRows.push({ id: 1, code: 1, desc: "", type: "", fieldLen: "", req: false })

    //re arrange id and code 
    const modifiedRowsArranged = modifiedRows.map((item, index) => {
      return {
        ...item,
        id: index + 1,
        code: index + 1
      }
    })
    setSetupArray(modifiedRowsArranged)
  }

  function handleRemoveRow(id) {
    const filteredRows = setupArray.filter(item => item.id !== id);

    //re arrange id and code
    const filteredRowsArranged = filteredRows.map((item, index) => {
      return {
        ...item,
        id: index + 1,
        code: index + 1
      }
    })

    setSetupArray(filteredRows.length === 0 ? [...newObjetcArray] : filteredRowsArranged);
  }


  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var LocationName = obj[4]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    var menuTAG = ""
    const AuditLog = {
      "strMenuCode": menu,
      "strUserName": LogUserType,
      "strLocCode": LocationCode,
      "strComcode": CompanyCode,
      "strReason": ""
    }
    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
      body: JSON.stringify(AuditLog),
    };

    fetch(`${ApiURL}login/menu/audit`, requestOptions)
      .then(async (response) => await response.json())
      .then(result => {

      }).catch(error =>
        console.log('error', error)
      );

  }, [])


  //*** Get and Set values when user search code */
  const getData = () => {
    fetch(`${ApiURL}groupsetup/search/${strFileNo}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {

          let data = responseData.data[0]

          SetFilename(data.gS_FILENAME)
          SetMenuNo(data.gS_MENUTAG)
          SetCodeLength(data.gS_CODELEN)
          SetDescLength(data.gS_DESCLEN)
          SetGSDet(data.groupSetDets)
          setCrBy(data.cR_BY)
          setMdBy(data.mD_BY)
          setCrDate(data.cR_DATE)
          setMdDate(data.mD_DATE == "1900-01-01T00:00:00" ? "" : data.mD_DATE)
          setCrEnable(true)
          setDisabledDesc(true)
          setDisabledCode(true)
          setSaveEnable(false)

          let modifiedRows = []
          data.groupSetDets.map((dr) => {
            modifiedRows.push({ id: modifiedRows.length + 1, code: dr.gS_FIELDID, desc: dr.gS_FIELDNAME, type: dr.gS_FIELDTYPE, fieldLen: dr.gS_FIELDLEN, req: dr.gS_FIELDREQ == "1" ? true : false })
          })

          setSetupArray(modifiedRows.length > 0 ? modifiedRows : [...newObjetcArray])
          SetAddNew(false)
        } else {
          displayAlertMessage('success', 'Record not found !')
        }
      })
  }

  const getDataSearch = (strFileNo) => {
    fetch(`${ApiURL}groupsetup/search/${strFileNo}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {

          let data = responseData.data[0]
          SetFilename(data.gS_FILENAME)
          SetMenuNo(data.gS_MENUTAG)
          SetCodeLength(data.gS_CODELEN)
          SetDescLength(data.gS_DESCLEN)
          SetGSDet(data.groupSetDets)
          setCrBy(data.cR_BY)
          setMdBy(data.mD_BY)
          setCrDate(data.cR_DATE)
          setMdDate(data.mD_DATE == "1900-01-01T00:00:00" ? "" : data.mD_DATE)
          setCrEnable(true)
          setDisabledDesc(true)
          setDisabledCode(true)
          setSaveEnable(false)
          let modifiedRows = []
          data.groupSetDets.map((dr) => {
            modifiedRows.push({ id: modifiedRows.length + 1, code: dr.gS_FIELDID, desc: dr.gS_FIELDNAME, type: dr.gS_FIELDTYPE, fieldLen: dr.gS_FIELDLEN, req: dr.gS_FIELDREQ == "1" ? true : false })
          })
          setSetupArray(modifiedRows.length > 0 ? modifiedRows : [...newObjetcArray])
          SetAddNew(false)
        }
      })
  }
  //*** End useEffect */

  const handleNew = () => {
    SetFileCode("")
    SetFilename("")
    SetMenuNo("")
    SetCodeLength("")
    SetDescLength("")
    SetGSDet([])
    setCrBy("")
    setMdBy("")
    setCrDate("")
    setMdDate("")
    setCrEnable(false)
    setSaveEnable(true)
    setDisabledDesc(false)
    setDisabledCode(false)
    setSetupArray([...newObjetcArray])
    setErrorMsg('')
    SetAddNew(true)
    setCurrentPage(1)
  }

  const handleEdit = () => {
    setSaveEnable(true)
    setDisabledDesc(false)

  }

  const handlesave = () => {
    //;
    if (strFileNo.length == 0) {
      displayAlertMessage('danger', "File No is Empty !")
      return;
    }
    if (strFilename.length == 0) {
      displayAlertMessage('danger', "File Name is Empty !")
      return;
    }
    var GROUPSETDET = []

    setupArray.forEach((item, index) => {
      if (item.desc.length != 0) {
        GROUPSETDET.push(GSDetBuilder(strFileNo, item.code, item.desc, item.type, item.fieldLen, item.req))
      }
    })

    var obj = JSON.parse(localStorage.getItem("authUser"))

    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menu = menuCode


    const GroupSetup = {
      LogUserType,
      strFileNo: parseInt(strFileNo),
      strFilename,
      strMenuNo,
      intCodeLength: parseInt(intCodeLength),
      intDescLength: parseInt(intDescLength),
      GROUPSETDET,
      "strMenuCode": menu,
      "strLoggedCompany": CompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": Reason,
      "strCreateBy": LogUserType,
      "blAddNew": addNew
    }

    fetch(`${ApiURL}GroupSetup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
      body: JSON.stringify(GroupSetup),
    }).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            if (responseData.data == "Record Already Exsist!") {
              displayAlertMessage('danger', responseData.data)
            } else if (responseData.data == "Code Already Exsist!") {
              displayAlertMessage('danger', responseData.data)
            } else {
              displayAlertMessage('success', responseData.data)
              handleNew();
            }
          }
          )
      } else if (Response.status == "400") {
        Response.json()
          .then(responseData => {

            setErrorMsg(responseData.msg)
          })
        setDisabled(false)
        setDisabledCode(false)
        //setShow3(true)
        displayAlertMessage('danger', "Oops something went wrong !")
      } else {
        handleNew();
      }
    })
  }
  const GSDetBuilder = (strFileNo, fieldID, fieldName, fieldType, fieldLen, fieldReq) => {
    //;
    return {
      "gS_FILENO": parseInt(strFileNo),
      "gS_FIELDID": parseInt(fieldID),
      "gS_FIELDNAME": fieldName,
      "gS_FIELDTYPE": parseInt(fieldType),
      "gS_FIELDLEN": parseInt(fieldLen),
      "gS_FIELDREQ": fieldReq ? 1 : 0
    }
  }
  //*End Function Declaration*/
  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetFileCode(row.GS_FILENO)
    getDataSearch(row.GS_FILENO)
    setmodal_xlarge(!modal_xlarge);
  }


  //**Permission Check */
  const permission = (operation) => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")
                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        handleNew()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  //Function for display Alert Messages.
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Group Master Setup</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {

                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/";
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 5) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  // handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              }
            }}
            onCancel={() => {
              setsweetAlertShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, true, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={Reason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              } else if (AlertConfirmOption == 6) {
                permission("Print")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?");
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable && isHeadOffice}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?");
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={!saveEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?");
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={false}
                    printClick={() => {
                      alert("Print")
                    }}
                    //Delete Button
                    deleteEnable={false}
                    deleteClick={() => {
                      alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?");
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    <p></p>
                    <Col sm={12} md={10} className="mb-4-sm">
                      <Row >
                        <GroupMasterSetupContent
                          strFileNo={strFileNo}
                          SetFileCode={e => {
                            SetFileCode(Numeric(e.target, 4, 0, false) == 0 ? "" : Numeric(e.target, 4, 0, false))
                          }}
                          strFilename={strFilename}
                          SetFilename={e => { SetFilename(Text(e.target, 50, true, false, "any", true)) }}
                          strMenuNo={strMenuNo}
                          SetMenuNo={e => { SetMenuNo(e.target.value) }}
                          disabledCode={disabledCode}
                          disabledDesc={disabledDesc}
                          intCodeLength={intCodeLength}
                          SetCodeLength={e => { SetCodeLength(Numeric(e.target, 4, 0, false) == 0 ? "" : Numeric(e.target, 4, 0, false)) }}
                          intDescLength={intDescLength}
                          SetDescLength={e => { SetDescLength(Numeric(e.target, 4, 0, false) == 0 ? "" : Numeric(e.target, 4, 0, false)) }}
                          setupArray={setupArray}
                          handleAddRowNested={handleAddRowNested}
                          RemoveRow={handleRemoveRow}
                          modelTrigger={tog_xlarge}
                          modelOpen={modal_xlarge}
                          GetSelectRow={GetSelectRow}
                          onCodeBlur={e => {
                            SetMenuNo("M003" + strFileNo.padStart(2, 0))
                            getData()
                          }}
                          show={show}
                          AlertColor={AlertColor}
                          AlertMsg={AlertMsg}
                          ErrorMsg={ErrorMsg}
                          menuCode={menuCode}
                          setSetupArray={setSetupArray}
                          disabled={disabled}
                          addNew={addNew}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                        />
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default GroupMasterSetup
